import { FC } from "react";
import { TaskDMPPayload } from "tm-shared/types";

import { useCompleteTask } from "@/domains/tasks/hooks";
import { makeCommand, useAsyncAction, useMakeCommand } from "@/hooks";
import { TaskFinishButton } from "@/pages/WorkPlan/Tasks/components/TaskFinishButton";
import { Loading } from "@/shared/feedback/Loading";
import { getPhotoIdsFromPhotoTask } from "@/utils/photo/getPhotoIdsFromPhotoTask";

interface TaskFinishProps {
    isAllCompleted: boolean;
    dmpPayloadMap: TaskDMPPayload | undefined;
    pointId: string;
    taskId: string;
}

export const TaskFinish: FC<TaskFinishProps> = ({
    isAllCompleted,
    dmpPayloadMap,
    pointId,
    taskId,
}) => {
    const completeTask = useCompleteTask({ targetId: pointId, taskId });

    const { makeTaskCompleteCommands, makeUploadPhotoCommands } =
        useMakeCommand();

    const [handleComplete, completeLoading] = useAsyncAction(async () => {
        if (!dmpPayloadMap) return;

        const photoIds = getPhotoIdsFromPhotoTask(dmpPayloadMap);
        const hasPhoto = photoIds.length > 0;

        const taskCompleteCommands = await makeTaskCompleteCommands({
            params: { taskId, hasPhoto, payload: dmpPayloadMap },
        });

        const commands = [
            ...makeUploadPhotoCommands(photoIds),

            ...taskCompleteCommands,

            makeCommand({
                type: "updatePhotoStorage",
                title: "Синхронізація сховища",
                params: photoIds,
                options: {
                    stopOnError: false,
                },
            }),
        ];

        completeTask({ commands });
    });

    return (
        <>
            <TaskFinishButton
                onClick={handleComplete}
                visible={isAllCompleted}
                padding="8px 16px"
                loading={completeLoading}
            />

            {completeLoading && <Loading title="Завершення задачі" />}
        </>
    );
};
